import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'reactstrap'
import NavBar from '../../components/Navbar'
import { Formik, Form, Field, FieldArray } from 'formik';
import * as Yup from "yup"
import { IJob, SectorsTr, SectorsEn } from "../../redux/types"
import { IJobPayload } from "../../redux/types"
import { useAppDispatch } from "../../redux/store"
import { useMediaQuery } from '@mui/material';
import "./styles.css"

import AddCircleIcon from '@mui/icons-material/AddCircle'
import { createNewJob } from '../../redux/slices/jobSlice';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitch from '../../components/LanguageSwitch';



interface InitialValuesType {
    title: string
    firm: string
    jobType: string
    // workType: string
    location: string
    sector: string
    jobDefinition: string,
    jobCriteria: []
}

export default function CreateJob() {

    const dispatch = useAppDispatch()

    const navigate = useNavigate()

    // const isMobile = useMediaQuery('(max-width:600px)');
    // const isTablet = useMediaQuery('(max-width:900px) and (min-width:601px)');
    // const isDesktop = useMediaQuery('(min-width:901px)');

    const [file, setFile] = useState<File | undefined>(undefined)
    const [fileString, setFileString] = useState("")
    const [lang, setLang] = useState<'tr' | 'en'>('tr');

    useEffect(() => {
        if (file) convert2base64(file)
        else setFileString("")

    }, [file])

    const { t, i18n } = useTranslation()

    const initialValues: InitialValuesType = {

        title: "",
        firm: "",
        jobType: "",
        // workType: "",
        location: "",
        sector: "",
        jobDefinition: "",
        jobCriteria: []
    }

    const validationSchema = Yup.object({
        title: Yup.string().required('Title is required'),
        firm: Yup.string().required('Firm is required'),

        location: Yup.string().required('Location is required'),
        sector: Yup.mixed<SectorsTr | SectorsEn>().oneOf(Object.values([...Object.values(SectorsTr), ...Object.values(SectorsEn)])).required('Sector is required'),
        jobDefinition: Yup.string().required("Job Criteria is required"),
        jobCriteria: Yup.array().of(Yup.string()).required("Job Criteria is required")
    });


    const convert2base64 = (file: File) => {
        const reader = new FileReader()

        reader.onloadend = () => {
            if (reader.result)
                setFileString(reader.result.toString())
        }

        reader.readAsDataURL(file)
    }

    return (
        <Container style={{ minHeight: "100vh" }}>
            <NavBar />
            <Row className='row-area' style={{ paddingTop: "50px" }}>
                <h3 style={{ textAlign: "center", fontSize: "26px" }} className='input-label'>Yeni İş Ekle</h3>

                <div className='d-flex mx-auto mt-2' style={{ justifyContent: "center", width: "40%" }}>
                    <LanguageSwitch value={lang} onChange={setLang} />
                </div>
                <p className='my-3' style={{ color: "red" }}>Türkçe oluşturulan işler sadece türkçe dil seçeneğinde gösterilecektir!! (İngilizce de aynı şekilde)</p>


                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={(values: InitialValuesType) => {


                        let payload: IJobPayload = {
                            ...values,
                            img: fileString ? fileString : "",
                            lang: lang,
                        }
                        // console.log(payload)
                        dispatch(createNewJob(payload))
                        navigate(-1)
                    }}
                >
                    {({ handleSubmit, values, errors, touched, submitCount }) => (
                        <Form style={{ textAlign: "start" }} onSubmit={handleSubmit}>
                            <div className="form-group row" >

                                <Col lg={6} md={12} sm={12} style={{ padding: "30px" }}>
                                    <label className='input-label' htmlFor="title" onClick={() => console.log(values)}>Başlık{ }</label>
                                    <Field name="title" type="text" className="form-control mb-4" id="title" placeholder="Başlık" />
                                    <div className='d-flex' style={{ justifyContent: "start" }}>
                                        <p style={{ color: "red" }}>
                                            {((touched.title || submitCount > 0) && errors.title) && errors.title}
                                        </p>
                                    </div>
                                    <label className='input-label' htmlFor="title">Firma</label>
                                    <Field name="firm" type="text" className="form-control mb-4" id="title" placeholder="Firma" />
                                    <div className='d-flex' style={{ justifyContent: "start" }}>
                                        <p style={{ color: "red" }}>
                                            {((touched.firm || submitCount > 0) && errors.firm) && errors.firm}
                                        </p>
                                    </div>
                                    {/* <label className='input-label' htmlFor="title">Çalışma Yeri</label>
                                    <Field name="workType" as="select" type="text" default="Uzaktan" className="form-control mb-4" id="title" placeholder="Çalışma Şekli" >
                                        <option value="" hidden>Sektör seçin</option>
                                        <option>Uzaktan</option>
                                        <option>Yüz yüze</option>
                                    </Field> */}
                                    {/* <div className='d-flex' style={{ justifyContent: "start" }}>
                                        <p style={{ color: "red" }}>
                                            {((touched.workType || submitCount > 0) && errors.workType) && errors.workType}
                                        </p>
                                    </div> */}
                                    <label className='input-label' htmlFor="title">Çalışma Şekli</label>
                                    <Field name="jobType" as="select" type="text" className="form-control mb-4" id="title" placeholder="Başlık" >
                                        <option value="" hidden>Çalışma şekli seçin</option>
                                        <option>Full-time</option>
                                        <option>Part-time</option>
                                    </Field>
                                    <div className='d-flex' style={{ justifyContent: "start" }}>
                                        <p style={{ color: "red" }}>
                                            {((touched.jobType || submitCount > 0) && errors.jobType) && errors.jobType}
                                        </p>
                                    </div>
                                    <label className='input-label' htmlFor="title">Konum</label>
                                    <Field name="location" type="text" className="form-control mb-4" id="title" placeholder="Şehir" />
                                    <div className='d-flex' style={{ justifyContent: "start" }}>
                                        <p style={{ color: "red" }}>
                                            {((touched.location || submitCount > 0) && errors.location) && errors.location}
                                        </p>
                                    </div>
                                </Col>

                                <Col lg={6} md={12} sm={12} style={{ padding: "30px" }}>


                                    <label className='input-label' htmlFor="title">Sektör</label>
                                    <Field name="sector" as="select" type="text" className="form-control mb-4" id="title" placeholder="Firma">
                                        <option value="" hidden>Sektör seçin</option>
                                        {Object.values(i18n.language === "tr" ? SectorsTr : SectorsEn).map((item, i) => {

                                            return (
                                                <option key={i}>{item}</option>
                                            )
                                        })}
                                    </Field>
                                    <div className='d-flex' style={{ justifyContent: "start" }}>
                                        <p style={{ color: "red" }}>
                                            {((touched.sector || submitCount > 0) && errors.sector) && errors.sector}
                                        </p>
                                    </div>
                                    <label className='input-label' htmlFor="title">Fotoğraf (isteğe bağlı)</label>
                                    <Field name="img" className="form-control mb-4">
                                        {({ field, form }) => (
                                            <input
                                                type="file"
                                                id="file"
                                                className="form-control"
                                                onChange={(event) => {
                                                    const file = event.currentTarget.files![0]
                                                    if (file) setFile(file);
                                                }}
                                            />
                                        )}
                                    </Field>

                                    <label className='input-label ' style={{ marginTop: "30px" }} htmlFor="title">Genel Nitelikler ve İş Tanımı</label>
                                    <Field name="jobDefinition" type="text" as="textarea" className="form-control mb-4" id="title" placeholder="İşi açıklayan yazı" />
                                    <div className='d-flex' style={{ justifyContent: "center" }}>
                                        <p style={{ color: "red" }}>
                                            {((touched?.jobDefinition || submitCount > 0)) && errors.jobDefinition}
                                        </p>
                                    </div>

                                    <FieldArray name="jobCriteria">
                                        {({ push, remove }) => (
                                            <div className="space-y-4">
                                                <label className='input-label '>İş Kriterleri</label>
                                                {values.jobCriteria.map((_, index) => (
                                                    <div key={index} className="d-flex items-center mb-4">
                                                        <Field
                                                            name={`jobCriteria[${index}]`}
                                                            type="text"
                                                            className="form-control"
                                                            id={`value-${index}`}
                                                            placeholder="Kriter"
                                                        />

                                                        <button type="button" className='btn btn-danger ms-4' onClick={() => remove(index)}>Sil</button>
                                                    </div>
                                                ))}
                                                <br />
                                                <button className='btn btn-primary' type="button" onClick={() => push("")}>
                                                    Alan Ekle
                                                </button>


                                            </div>
                                        )}
                                    </FieldArray>
                                    <div className='d-flex' style={{ justifyContent: "start" }}>
                                        <p style={{ color: "red" }}>
                                            {((touched.jobCriteria || submitCount > 0) && errors.jobCriteria) && errors.jobCriteria}
                                        </p>
                                    </div>
                                </Col>

                            </div>



                            <div className='d-flex mt-4'>
                                <button type="submit" className="btn btn-success btn-lg mx-auto mt-4">
                                    Ekle
                                </button>
                            </div>

                        </Form>
                    )}
                </Formik>
            </Row>
        </Container>
    )
}

